import { useEffect, useState } from 'react';
import { HashLoader } from 'react-spinners';

import { AmenityData, useGetAmenities } from 'api/get-amenities';

import { ModalButton } from 'components/base/button';
import { Modal } from 'components/base/modal';
import { Select } from 'components/base/select';

import * as S from './widget-amenity-data-modal.styled';

interface WidgetAmenityDataModalProps {
  amenity?: AmenityData;
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: AmenityData) => void;
  submitText?: string;
}

export const WidgetAmenityDataModal = ({
  isOpen,
  amenity,
  onClose,
  onSubmit,
  submitText,
}: WidgetAmenityDataModalProps) => {
  const { data: amenities = [], isLoading } = useGetAmenities();
  const [amenityId, setAmenityId] = useState<number | undefined>(amenity?.id);

  const onAmenityChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setAmenityId(Number(e.target.value));
  };

  const onSave = () => {
    const amenity = amenities?.find((amenity) => amenity.id === amenityId);
    if (amenity) {
      onSubmit(amenity);
    }
  };

  const renderBody = () => {
    if (isLoading) {
      return (
        <S.Loading>
          <HashLoader />
        </S.Loading>
      );
    }

    return (
      <S.Wrapper>
        <Select
          options={amenities.map((amenity) => ({
            value: amenity.id,
            label: amenity.name,
          }))}
          label="Select Amenity to Display"
          id="amenityId"
          name="amenity"
          value={amenityId}
          onChange={onAmenityChange}
        />
      </S.Wrapper>
    );
  };

  useEffect(() => {
    if (amenities.length > 0 && !amenityId) {
      setAmenityId(amenities[0].id);
    }
  }, [amenities, amenityId]);

  return (
    <Modal
      hideScroll
      onClose={onClose}
      isOpen={isOpen}
      header="Widget Settings"
      size="small"
      footer={
        <ModalButton type="submit" onClick={onSave} disabled={!amenityId}>
          {submitText ?? 'Place Widget'}
        </ModalButton>
      }
    >
      {renderBody()}
    </Modal>
  );
};
